export default "__VITE_ASSET__Cp5x4wrc__"